import { useState } from "react";
import { useTranslation } from "react-i18next";
import { HelpCircle, X } from "lucide-react";

export function MarkdownHelp() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div className="relative inline-block">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="inline-flex items-center gap-1 text-xs text-blue-500 hover:text-blue-700 transition-colors"
        data-testid="markdown-help-btn"
      >
        <HelpCircle className="h-3.5 w-3.5" />
        {t('markdown.helpLabel')}
      </button>
      {open && (
        <div className="absolute z-50 left-0 top-7 w-80 bg-white border border-slate-200 rounded-lg shadow-lg p-4 text-sm">
          <div className="flex items-center justify-between mb-3">
            <span className="font-semibold text-slate-800">{t('markdown.helpTitle')}</span>
            <button type="button" onClick={() => setOpen(false)} className="text-slate-400 hover:text-slate-600">
              <X className="h-4 w-4" />
            </button>
          </div>
          <table className="w-full text-xs">
            <thead>
              <tr className="border-b border-slate-100">
                <th className="text-left py-1.5 text-slate-500 font-medium">{t('markdown.youWrite')}</th>
                <th className="text-left py-1.5 text-slate-500 font-medium">{t('markdown.youSee')}</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              <tr>
                <td className="py-1.5 font-mono text-slate-600">**{t('markdown.boldExample')}**</td>
                <td className="py-1.5"><strong>{t('markdown.boldExample')}</strong></td>
              </tr>
              <tr>
                <td className="py-1.5 font-mono text-slate-600">*{t('markdown.italicExample')}*</td>
                <td className="py-1.5"><em>{t('markdown.italicExample')}</em></td>
              </tr>
              <tr>
                <td className="py-1.5 font-mono text-slate-600">***{t('markdown.bothExample')}***</td>
                <td className="py-1.5"><strong><em>{t('markdown.bothExample')}</em></strong></td>
              </tr>
              <tr>
                <td className="py-1.5 font-mono text-slate-600 whitespace-pre">- Element 1{"\n"}- Element 2</td>
                <td className="py-1.5">
                  <ul className="list-disc list-inside">
                    <li>Element 1</li>
                    <li>Element 2</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
